// Client-side bot/automation detection — first line of defence; server has its own.
export function isBot() {
  if (typeof navigator === "undefined") return true;
  if (navigator.webdriver) return true;
  if (!navigator.languages || navigator.languages.length === 0) return true;
  const ua = (navigator.userAgent || "").toLowerCase();
  if (!ua) return true;
  const patterns = [
    "bot", "crawler", "spider", "scraper", "headless", "phantomjs",
    "puppeteer", "playwright", "lighthouse", "pagespeed",
  ];
  for (const p of patterns) if (ua.indexOf(p) !== -1) return true;
  return false;
}

export function respectsDnt() {
  return navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.msDoNotTrack === "1";
}
